import Rete from "rete"

import CustomNode from './CustomNode.vue'
import * as Socket from "../sockets"
import { ItemChooserControl } from "../controls/ItemChooserControl.js"

import store from "../../store"

export class GameComponent extends Rete.Component {
  constructor(node_type) {
    // Use the node type slug as component name
    super(node_type.slug)

    this.data = {
      render: 'vue',
      component: CustomNode,
      props: {
        title: node_type.name,
        description: node_type.description,
      }
    }
  }

  builder(node) {
    const next = new Rete.Output("next", "Noeud suivant", Socket.trigger, false)//todo: comon ?
    const success = new Rete.Output("success", "Succès", Socket.trigger, false)
    const failure = new Rete.Output("failure", "Échec", Socket.trigger, false)
    const previous = new Rete.Input("previous", "", Socket.triggered, true)
    const control = new ItemChooserControl("game", "Jeu", { store: { module: "Games", state: "list" } })
    
    return node
      .addInput(previous)
      .addControl(control)
      .addOutput(next)
      // todo: add/remove with trigger type data from db
      // .addOutput(success)
      // .addOutput(failure)
  }
}
